import React, { useState } from 'react';
import groupBy from 'lodash/groupBy';

import './styles.scss';

import PolicyIcon from '../PolicyIcon';
import DisclosurePanel from '../DisclosurePanel';
import StatusFlag from '../StatusFlag';
import Tags, { Tag } from '../Tags';
import DonutChart from '../donutchart/donutchart.jsx';
import PolicyLabel from '../PolicyLabel/index.js';
import { PolicyMarkerIcon } from '../PolicyMarker';
import SourceLink from '../SourceLink';
import Button from '../button/button.jsx';
import IconButton from '../icon-button/icon-button.jsx';

import { POLICIES_STATUSES } from '../../constants.js';

export default function PolicyDetails({ policy, policyType, onClickBack }) {
  const [activeTheme, setActiveTheme] = useState(null);

  const displayedActions = activeTheme
    ? policy.actions.filter((x) => x.theme === activeTheme)
    : policy.actions;
  const actionsByTheme = groupBy(displayedActions, 'theme');
  const actionsByStatus = groupBy(displayedActions, 'status');

  const donutChartValues = [];
  const donutChartColours = [];
  const donutChartKeyStatuses = [];
  POLICIES_STATUSES.forEach((status) => {
    if (actionsByStatus[status.id]) {
      donutChartValues.push(actionsByStatus[status.id].length / displayedActions.length);
      donutChartColours.push(status.colour);
      donutChartKeyStatuses.push(status);
    }
  });

  const handleClickTheme = (theme) => () => {
    setActiveTheme(theme);
  };

  return (
    <div className="policy-details">
      <div className="policy-details__header">
        {activeTheme ? (
          <IconButton key="theme" kind="back" icon="chevron" handleClick={handleClickTheme(null)}>
            {policy.title}
          </IconButton>
        ) : (
          <IconButton key="policy" kind="back" icon="chevron" handleClick={onClickBack}>
            {policyType.model.name}
          </IconButton>
        )}
        <h1>{activeTheme ? activeTheme : policy.title}</h1>
        {/* <div className="policy-details__statistics">
          <DonutChart
            values={donutChartValues}
            colours={donutChartColours}
            formattedValue={displayedActions.length}
            title="Total number of actions"
            size="large"
          />
          <ul className="policy-details__statistics__legend">
            {donutChartKeyStatuses.map((status) => {
              return (
                <li>
                  <PolicyMarkerIcon colour={status.colour} />
                  {status.name}
                </li>
              );
            })}
          </ul>
        </div> */}
      </div>
      <div className="policy-details__body">
        {!activeTheme ? (
          <div className="policy-details__section">
            <h4 className="policy-details__section__header">Themes</h4>
            <ul className="policy-details__themes">
              {Object.keys(actionsByTheme)
                .sort()
                .map((theme) => {
                  return (
                    <li className="policy-details__theme">
                      <button type="button" onClick={handleClickTheme(theme)}>
                        {theme} ({actionsByTheme[theme].length} actions)
                      </button>
                    </li>
                  );
                })}
            </ul>
          </div>
        ) : undefined}
        {activeTheme ? (
          <div className="policy-details__section">
            <h4 className="policy-details__section__header">{displayedActions.length} actions</h4>
            <div>
              <ul className="policy-details__actions">
                {displayedActions.map((action) => {
                  const status = POLICIES_STATUSES.find((x) => x.id === action.status);

                  return (
                    <li className="policy-details__action">
                      <p>{action.title}</p>
                      <div className="policy-details__action__tags">
                        {/* {status ? (
                          <PolicyLabel colour={status.colour}>{status.name}</PolicyLabel>
                        ) : undefined} */}
                        {/* XXX: Disable display of sectors temporarily while data is incorrect */}
                        {/* {action.sectors && action.sectors.length ? (
                          <Tags>
                            {action.sectors.map((sector) => (
                              <Tag>{sector}</Tag>
                            ))}
                          </Tags>
                        ) : undefined} */}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        ) : undefined}
        {!activeTheme ? (
          <>
            {policy.responsibleDetail && (
              <div className="policy-details__section">
                <h4 className="policy-details__section__header">Responsible stakeholders</h4>
                <div className="policy-details__section__body">
                  <p dangerouslySetInnerHTML={{ __html: policy.responsibleDetail }} />
                </div>
              </div>
            )}
            {policy.source && (
              <div className="policy-details__section">
                <h4 className="policy-details__section__header">Sources</h4>
                <div className="policy-details__section__body">
                  <ul>
                    {policy.source.map((source) => {
                      return (
                        <li>
                          <SourceLink href={source} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}
          </>
        ) : undefined}
      </div>
    </div>
  );
}
